import { Component, input, output, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from '../../../shared/modal/modal.component';
import { AuthApiService } from '../../../core/services/auth-api.service';
import { FORM_FIELD_LIMITS } from '../../../core/constants/form-field-limits';
import { isValidEmailFormat } from '../../../core/utils/form-field-validation';

@Component({
  selector: 'app-forgot-password-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalComponent],
  templateUrl: './forgot-password-modal.component.html',
  styleUrl: './forgot-password-modal.component.scss',
})
export class ForgotPasswordModalComponent {
  readonly limits = FORM_FIELD_LIMITS;

  isOpen = input.required<boolean>();

  closed = output<void>();

  private authApi = inject(AuthApiService);

  email = signal('');
  loading = signal(false);
  errorMessage = signal('');
  successSent = signal(false);

  onClose(): void {
    this.errorMessage.set('');
    this.successSent.set(false);
    this.closed.emit();
  }

  onSubmit(): void {
    const e = this.email().trim();
    this.errorMessage.set('');
    if (!e) {
      this.errorMessage.set('Informe o e-mail.');
      return;
    }
    if (!isValidEmailFormat(e)) {
      this.errorMessage.set('Informe um e-mail válido.');
      return;
    }
    this.loading.set(true);
    this.authApi.forgotPassword({ email: e }).subscribe({
      next: () => {
        this.loading.set(false);
        this.successSent.set(true);
      },
      error: (err) => {
        this.loading.set(false);
        const message =
          err?.error?.message ??
          err?.error?.error ??
          (typeof err?.error === 'string' ? err.error : null) ??
          'Não foi possível enviar o e-mail. Tente novamente.';
        this.errorMessage.set(message);
      },
    });
  }
}
